




















































































































































































































































import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import t from '@/utils/tools'
import d from '@/utils/imports'
import af from '@/utils/authorized_formats'
import FileUpload from '@/components/file_upload'


export default {
    name: 'users_jobs'
    components: {
        FileUpload
    }
    props: {
        uid: {
            type: String
        }
    }
        
    data: ()->
        false: false
        true: true
        pager_count: 5
        current_page: 1
        page_size: 10
        search: ''
        loading: true
        alert: false
        errors: {}
        active_names: [1]
        job_creation_explanation: "Création d'un métier : écrire le nom du métier puis le sélectionner dans la liste déroulante en cliquant dessus."
        contract_type_choice_set: []
        status_choice_set: @$store.state.employee_status_choice_set
        graduate_level_choice_set: @$store.state.graduate_level_choice_set
        # step_options: [
        #     {value:0, label:'Aucun'}
        #     {value:1, label:'1'}
        #     {value:2, label:'2'}
        #     {value:3, label:'3'}
        # ]
        unity_options: [
            {value:1, label:'Jour(s)'}
            {value:2, label:'Mois'}
        ]
        step_coef: 5
        step_weekly_hours: 0.01
        min: 100
        min_duration: 0
        display_employer: false
        display_organization: false
        clearable: true
        picker_options: {firstDayOfWeek:1}
        max_filesize: af['user_job']['file']['max_filesize']/1024/1024
        authorized_formats: af['user_job']['file']['authorized_formats']
        userjob: {
            uid: ''
            user_uid: @uid
            step: 0
            level: {uid:''}
            contract_type: {uid:''}
            status: {uid:''}
            weekly_hours: ''
            coefficient: ''
            partial_time: false
            notice_duration_unity: 1
            trial_duration_unity: 1
            notice_duration: ''
            trial_duration: ''
            renew_trial: false
            idcc: ''
            reference: ''
            start: ''
            end: ''
            establishments: []
            job_uid_or_new: ''
            service_name: ''
            employer_name: ''
            employer_address: ''
            organization_name: ''
            tutor_name: ''
            interviews: ['','','']
            file_name: ''
            file_data: ''
            file: ''
            file_dir: ''
        }
        jobs: []
        establishments: []
        userjobs: []
        job_button: false
        job_key: ''

    computed:
        data_filtered: ()->
            self = @
            data = @userjobs.filter (x)->
                end = service_name = weekly_hours = notice_duration = trial_duration = false
                establishments = ""
                # renew_trial = 'non'
                # if x.renew_trial
                #     renew_trial = 'oui'
                if x.end?
                    end = self.date_formatter(x.end).toLowerCase().includes(self.search.toLowerCase())
                if x.service_name?
                    service_name = x.service_name.toLowerCase().includes(self.search.toLowerCase())
                # if x.weekly_hours?
                #     weekly_hours = x.weekly_hours.toString().toLowerCase().includes(self.search.toLowerCase()) 
                # if x.notice_duration?
                #     notice_duration = x.notice_duration.toString().toLowerCase().includes(self.search.toLowerCase()) 
                # if x.trial_duration?
                #     trial_duration = x.trial_duration.toString().toLowerCase().includes(self.search.toLowerCase()) 
                for item in x.establishments
                    establishments += item.name+" "
                !self.search || service_name \
                || x.job.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.job.name.toLowerCase().includes(self.search.toLowerCase())\
                || self.date_formatter(x.start).toLowerCase().includes(self.search.toLowerCase()) \
                || end \
                # || renew_trial.includes(self.search.toLowerCase()) \
                # || x.step.toLowerCase().includes(self.search.toLowerCase()) \
                || x.level.label.toLowerCase().includes(self.search.toLowerCase()) \
                || x.contract_type.label.toLowerCase().includes(self.search.toLowerCase()) \
                || x.status.label.toLowerCase().includes(self.search.toLowerCase()) \
                # || weekly_hours \
                # || x.coefficient.toLowerCase().includes(self.search.toLowerCase()) \
                # || notice_duration \
                # || trial_duration \
                || x.reference.toLowerCase().includes(self.search.toLowerCase()) \
                || x.idcc.toLowerCase().includes(self.search.toLowerCase()) \
                || establishments.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || establishments.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        save_text: ()->
            text = "Ajouter"
            if @userjob.uid != ''
                text = "Enregistrer"
            return text

        toggle_collapse_text: ()->
            text = "Ajouter un contrat"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

        has_mutation_right: ()->
            return @has_access_right(@get_access('edit'))

        has_deletion_right: ()->
            return @has_access_right(@get_access('delete'))

        ref_readonly: ()->
            return !t.has_access_right(d['users_jobs']['access_set'][0])

        doc_url: ()->
            return settings.document_url

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right

        job_change: ()->
            reg = @userjob.job_uid_or_new.match(/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/)
            if reg != null and reg.length > 0
                @job_button = true
            else
                @job_button = false
            @job_key = +new Date()
            return

        contract_changed: (value)->
            # console.log "CONTRACT CHANGED ", value
            for c in @contract_type_choice_set
                if c.uid == value
                    if c.slug == 'travail_temporaire' or c.slug == 'groupement_employeur'
                        @display_organization = false
                        @display_employer = true
                        return
                    if c.slug == 'convention_stage'
                        @display_organization = true
                        @display_employer = false
                        return
            @display_employer = false
            @display_organization = false
            return

        download_file: (userjob)->
            url = settings.media_url+userjob.file_dir+'/'+userjob.file
            filename = userjob.complete_filename
            t.download_file(url, filename)
            return

        start_change: ()->
            if @userjob.start?
                start = @userjob.start.split('-')
                @userjob.interviews[0] = parseInt(start[0])+2
                @userjob.interviews[1] = parseInt(start[0])+4
                @userjob.interviews[2] = parseInt(start[0])+6
            return

        reset_userjob: ()->
            @userjob = {
                uid: ''
                user_uid: @uid
                step: 0
                level: t.deep_copy(@graduate_level_choice_set[0])
                contract_type: t.deep_copy(@contract_type_choice_set[0])
                status: t.deep_copy(@status_choice_set[0])
                weekly_hours: ''
                coefficient: ''
                partial_time: false
                notice_duration_unity: 1
                trial_duration_unity: 1
                notice_duration: ''
                trial_duration: ''
                renew_trial: false
                idcc: ''
                reference: ''
                start: ''
                end: ''
                establishments: []
                job_uid_or_new: ''
                service_name: ''
                employer_name: ''
                employer_address: ''
                organization_name: ''
                tutor_name: ''
                interviews: ['','','']
                file_name: ''
                file_data: ''
                file: ''
                file_dir: ''
            }
            return

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @userjobs.sort (a,b)->
                field_a = field_b = ""
                if prop in ['job.name', 'contract_type.label', 'level.label', 'status.label']
                    props = prop.split('.')
                    field_a = a[props[0]][props[1]]
                    field_b = b[props[0]][props[1]]
                else if prop == 'establishments.name'
                    for e in a.establishments
                        field_a += e.name+','
                    for e in b.establishments
                        field_b += e.name+','
                # else if prop in ['trial_duration', 'notice_duration', 'weekly_hours']
                #     if a[prop] != null
                #         field_a = a[prop].toString()
                #     if b[prop] != null
                #         field_b = b[prop].toString()
                # else if prop == 'renew_trial'
                #     field_a = 'non'
                #     field_b = 'non'
                #     if a[prop]
                #         field_a = 'oui'
                #     if b[prop]
                #         field_b = 'oui'
                else
                    if a[prop] != null
                        field_a = a[prop]
                    if b[prop] != null
                        field_b = b[prop]
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        interview_change: (index)->
            tmp = parseInt(@userjob.interviews[index], 10)
            # console.log "IC", tmp, isNaN(tmp)
            if isNaN(tmp)
                @userjob.interviews[index] = ''
            else
                @userjob.interviews[index] = tmp
                if index in [0,1]
                    for i in [index+1 .. 2]
                        @userjob.interviews[i] = @userjob.interviews[i-1] + 2
            return

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_userjob()
            #if @$refs.file_upload?
            #    @$refs.file_upload.clearFiles()
            @job_change()
            return

        handle_tmp_file_remove: (file, fileList)->
            @$refs.file_upload.clearFiles()
            @userjob.file_data = ''
            @userjob.file_name = ''
            return

        handle_file_remove: ()->
            @userjob.file = ''
            @userjob.file_dir = ''
            return

        handle_file_change: (file, fileList)->
            is_good_ext = file.raw.type in af['user_job']['file']['mime_types']
            is_good_size = file.size < af['user_job']['file']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+' .')
                fileList.pop()
                return
            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.userjob.file_data = e.target.result
                self.userjob.file_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @userjob
            return

        edit_userjob: (index)->
            @userjob = t.deep_copy(@userjobs[index])
            @userjob.establishments = @userjob.establishments.map (e)-> e.uid
            @userjob.job_uid_or_new = @userjob.job.uid
            @active_names = [1, "1"]
            @$root.$el.scrollTop = 0
            @job_change()
            @errors = {}
            # console.log "EDIT USERJOB ", @userjobs[index]
            return

        get_access: (suffix)->
            access = "users_jobs_self_"+suffix
            if @$route.name == 'company_users_jobs'
                access = "users_jobs_"+suffix
            return access

        delete_userjob: (userjob_uid)->
            # console.log  "DELETE USERJOB", userjob_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce contrat ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "USERJOB DELETE", userjob_uid
                    m.run('delete_object', ['user_job', userjob_uid])
                    .then (resp)->
                        # console.log "DELETE USERJOB", resp.body.data.user_job_deletion
                        if resp.body.data.user_job_deletion.ok
                            n.success()
                            self.get_userjobs()
                        else
                            n.gql_error("users_jobs: delete_userjob: then", resp.body.data.user_job_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_jobs: delete_userjob()")
                .catch (cancel)->
                    return

        save: ()->
            # console.log "SAVE USERJOB", @userjob
            self = @
            @userjob.user_uid = @uid
            # if @userjob.step == null
            #     @userjob.step = ""
            m.run('save_userjob', [@userjob])
            .then (resp)->
                if resp.body.data.user_job_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.user_job_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.user_job_form_mutation.errors
                    self.errors = resp.body.data.user_job_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    console.log("resp", resp)
                    await self.$refs.file_upload.save_from_parent(
                      resp.body.data.user_job_form_mutation.form_ret)
                    self.errors = {}
                    n.success()
                    self.reset_userjob()
                    #if self.$refs.file_upload?
                    #    self.$refs.file_upload.clearFiles()
                    self.active_names = [1]
                    self.get_userjobs()
                    self.get_jobs()
            .catch (resp)->
                n.catch_error(resp, "users_jobs: save()")

        get_userjobs: ()->
            self = @
            @loading = true
            q.run('get_userjob_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_jobs: get_userjobs: then", e.message)
                else
                    # console.log "GET USERJOBS : ", resp.body.data.user_job_set
                    self.userjobs = resp.body.data.user_job_set
                    self.loading = false
                    if self.userjobs.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "users_jobs: get_userjobs()")

        get_jobs: ()->
            self = @
            q.run('get_users_jobs_job_set', [@$store.getters.current_company.uid, @uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_jobs: get_jobs: then", e.message)
                else
                    # console.log "GET JOBS : ", resp.body.data.users_jobs_job_set
                    self.jobs = resp.body.data.users_jobs_job_set
            .catch (resp)->
                n.catch_error(resp, "users_jobs: get_jobs()")

        get_establishments: ()->
            self = @
            q.run('get_users_jobs_establishment_set', [@$store.getters.current_company.uid, @uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_jobs: get_establishments: then", e.message)
                else
                    # console.log "GET ESTABLISHMENTS : ", resp.body.data.users_jobs_establishment_set
                    self.establishments = resp.body.data.users_jobs_establishment_set
            .catch (resp)->
                n.catch_error(resp, "users_jobs: get_establishments()")

        get_contract_type_choice_set: ()->
            self = @
            @errors = {}
            q.run('get_type_set', ['contract_choice'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_jobs: get_contract_type_choice_set: then" ,e.message)
                else
                    # console.log "GET CONTRACT TYPE CHOICE SET : ", resp.body.data.contract_choice_set
                    self.contract_type_choice_set = resp.body.data.contract_choice_set
            .catch (resp)->
                n.catch_error(resp, "users_jobs: get_contract_type_choice_set()")
            
    beforeMount: ()->
        @get_jobs()
        @get_establishments()
        @get_contract_type_choice_set()
        if @uid != '0'
            @get_userjobs()
}
